import React, { useRef } from "react";
import { useTranslation } from "react-i18next";

import "../facility/facility.scss";

import Page from "components/page/Page";
import Card from "components/card/Card";
import Flag from "components/flag/Flag";
import { Select } from "components/select/index";

export default function Language() {
  const { t, i18n } = useTranslation();
  const { Option } = Select;
  const refresh = useRef(false);
  
  const lngs: { [index: string]: any } = {
    "en-CA": { nativeName: "English", countryCode: "ca" },
    "fr-CA": { nativeName: "French", countryCode: "ca" },
    "fr-FR": { nativeName: "French", countryCode: "fr" },
  };

  function handleDropDownChange(value: string) {
    if(refresh.current === true){
      void i18n.changeLanguage(value);
      window.location.reload();
    } else {
      refresh.current = true;
    }
  }

  return (
    <Page title={t("Language")} narrow>
      <Card>
        <Card.Section>
          <Select
            label={t("Select Language")}
            defaultValue={i18n.language}
            onChange={handleDropDownChange}
          >
            {Object.keys(lngs).map(lng => (
              <Option key={lng} value={lng}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span style={{ marginRight: "1rem" }}>
                    <Flag countryCode={lngs[lng].countryCode} />
                  </span>
                  <span>{lngs[lng].nativeName}</span>
                </div>
              </Option>
            ))}
          </Select>
        </Card.Section>
      </Card>
    </Page>
  );
}
